import { useToday } from "./useToday";

/** A failed background refresh must not clear the signal: money is held behind
 *  every unit of it, so a stale count beats a silent zero. */
export function useAwaitingAnswerCount(): number | null {
  const { today } = useToday();

  if (!today) return null;

  return today.awaitingAnswer.length;
}
